import Vue from 'vue'
// import VueRouter from 'vue-router'
import i18n from '@/i18n'
import store from '@/store'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import GqlClient from './lib/GqlClient'
import Logger from '@/lib/Logger'
// import version from './version.js'
import VueGtag from 'vue-gtag'

Vue.config.productionTip = false
/* global LOG_LEVEL */
Logger.setLevel(LOG_LEVEL())
// Vue.use(VueRouter)
// Vue.use(vuetify);

Vue.use(
  VueGtag,
  {
    config: { id: 'UA-691929-27' },
  },
  router,
)

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App),
  created() {
    // this.loadedVersion = version
    // Logger.debug('Frontend Version:', this.loadedVersion)
    try {
      GqlClient.reloadAuthString()
      Logger.debug('localStorage.sharylist_user: ', localStorage.sharylist_user)

      if (GqlClient.isLogged()) {
        const user = JSON.parse(localStorage.sharylist_user)
        this.$gtag.set({ user_id: user.id })
        Logger.debug('gtag config user_id:', user.id)
        this.$store.commit('userLoggedIn', user)
      }
    } catch (e) {
      Logger.error(e)
    }
  },
}).$mount('#app')
